import Input from "@/components/input/Input";
import { MdOutlineEmail } from "react-icons/md";
import { RiLockPasswordLine } from "react-icons/ri";

function MainDataInputs({
    isRequired,
    register,
    getValues,
    isPending,
    errors,
    ApiError,
}) {
    return (
        <>
            {/* Email */}
            <Input
                type="email"
                name="email"
                id="email"
                disabled={isPending}
                label="البريد الإلكتروني*"
                icon={MdOutlineEmail}
                register={
                    register &&
                    register("email", {
                        ...(isRequired ? { required: isRequired } : {}),
                        pattern: {
                            value: /\S+@\S+\.\S+/,
                            message: "يرجى كتابة عنوان بريد إلكتروني صالح",
                        },
                    })
                }
                error={
                    errors?.email?.message ||
                    ApiError?.response?.data?.errors?.email?.[0]
                }
            />

            {/* Password */}
            <Input
                label="كلمة السر*"
                name="password"
                type="password"
                disabled={isPending}
                icon={RiLockPasswordLine}
                error={
                    errors?.password?.message ||
                    ApiError?.response?.data?.errors?.password?.[0]
                }
                register={
                    register &&
                    register("password", {
                        ...(isRequired ? { required: isRequired } : {}),
                        pattern: {
                            value: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d\W]{8,}/,
                            message:
                                "يجب أن تكون كلمة المرور الخاصة بك 8 أحرف على الأقل وأن تحتوي على أحرف وأرقام..",
                        },
                    })
                }
            />

            {/* PasswordConfirmaion */}
            <Input
                label="تأكيد كلمة السر*"
                name="passwordConfirmation"
                type="password"
                icon={RiLockPasswordLine}
                disabled={isPending}
                error={
                    errors?.passwordConfirmation?.message ||
                    ApiError?.response?.data?.errors?.password_confirmation?.[0]
                }
                register={
                    register &&
                    register("passwordConfirmation", {
                        ...(isRequired ? { required: isRequired } : {}),
                        validate: {
                            validate: (value) =>
                                value !== getValues().password
                                    ? "كلمة المرور وتأكيد كلمة المرور غير متطابقين."
                                    : true,
                        },
                    })
                }
            />
        </>
    );
}

export default MainDataInputs;
